import React from 'react';
import LocationAddEditModal from './locationmasters-add-edit';
import LocationPrintModal from './locationmasters-print-modal';

import { MODAL_TYPES } from 'Feature/components/app-modals';

const { LOCATION_ADD_EDIT } = MODAL_TYPES;

const LocationModals = () => {
  return (
    <>
      <LocationAddEditModal modalId={LOCATION_ADD_EDIT} />
      <LocationPrintModal modalId={MODAL_TYPES.LOCATION_PRINT_MODAL} />

    </>
  );
};

export default LocationModals;
